import { render, staticRenderFns } from "./contact-statuses-widget.vue?vue&type=template&id=17c4d754&"
import script from "./contact-statuses-widget.vue?vue&type=script&lang=js&"
export * from "./contact-statuses-widget.vue?vue&type=script&lang=js&"
import style0 from "./contact-statuses-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports